export default "__VITE_ASSET__C3ePi_XN__"